import { apiSlice } from '../../api/apiSlice';

export const studentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTeachersBySchoolId: builder.mutation({
      query: (schoolId) => ({
        url: `student/school/${schoolId}`,
        method: 'GET',
        credentials: 'include'
      })
    }),
    clearStudentPassword: builder.mutation({
      query: (options) => ({
        url: 'student/ClearPassword?classId='+ options.classId,
        method: 'PUT',
        body: options.studentIds,
        credentials: 'include'
      })
    }),
    getStudentCategories: builder.mutation({
      query: (schoolId) => ({
        url: 'student/categories',
        method: 'GET',
        params: {schoolId:schoolId}
      })
    }),
    getAllAdmins: builder.mutation({
      query: (schoolId) => ({
        url: `student/school/${schoolId}/admins`,
        method: 'GET'
      })
    }),
    updateTextSelection: builder.mutation({
      query: (options) => ({
        url: `student/class/${options.classId}/TextSelection`,
        method: 'PUT',
        body: options
      })
    }),
    updateReadSpeaker: builder.mutation({
      query: (options) => ({
        url: `student/class/${options.classId}/ReadSpeaker`,
        method: 'PUT',
        body: options
      })
    }),
    getAdminList: builder.mutation({
      query: () => ({
        url: 'student/admins',
        method: 'GET',
        credentials: 'include'
      })
    }),
    updateDefaultLandingPage: builder.mutation({
      query: (options) => ({
        url: `Student/DefaultLandingPage?isDefaultClassic=${options.isDefaultClassic}`,
        method: 'PUT',
        credentials: 'include'
      })
    }),
    getAssignedStudentsByClasses: builder.mutation({
      query: (options) => {
        return {
          url: `Student/AssignedByClassIds/${options.skip}/${options.take}?assignmentId=${options.assignmentId}`,
          method: 'POST',
          body: options.classIds
        };
      }
    })
  })
});

export const {
  useGetTeachersBySchoolIdMutation,
  useClearStudentPasswordMutation,
  useGetStudentCategoriesMutation,
  useGetAllAdminsMutation,
  useUpdateTextSelectionMutation,
  useUpdateReadSpeakerMutation,
  useGetAdminListMutation,
  useUpdateDefaultLandingPageMutation,
  useGetAssignedStudentsByClassesMutation
} = studentApi;